import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "table table-hover" }
const _hoisted_2 = { class: "pb-2 border-dark border-bottom" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  colspan: "3",
  class: "fw-bold small text-uppercase text-muted"
}
const _hoisted_6 = { class: "buttons" }
const _hoisted_7 = { class: "d-flex justify-content-end" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "edit", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_base_placeholder_table = _resolveComponent("base-placeholder-table")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_container = _resolveComponent("base-container")!

  return (_openBlock(), _createBlock(_component_base_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_BaseTitle, {
        title: _ctx.$t('footers'),
        "back-route": {name: 'content-pages'},
        "help-text": "Voorbeeld van een helptekst.",
        mb: 5
      }, null, 8, ["title"]),
      _createVNode(_component_AlertError2, {
        error: this.footerStackOverviewUI.getError()
      }, null, 8, ["error"]),
      _createElementVNode("table", _hoisted_1, [
        _createElementVNode("thead", _hoisted_2, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", null, _toDisplayString(_ctx.$t('type')), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t('layout')), 1),
            _hoisted_3
          ])
        ]),
        _createElementVNode("tbody", null, [
          (this.footerStackOverviewUI.isNotReady())
            ? (_openBlock(), _createBlock(_component_base_placeholder_table, {
                key: 0,
                "n-cols": 3
              }))
            : (this.footerStackOverviewUI.isReady() && !this.hasFooterStacks)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_4, [
                  _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.$t('noResults')), 1)
                ]))
              : (this.footerStackOverviewUI.isReady() && this.hasFooterStacks)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(this.footerStacks, (footerStack) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: footerStack.id
                    }, [
                      _createElementVNode("td", null, _toDisplayString(footerStack.type?.description), 1),
                      _createElementVNode("td", null, _toDisplayString(footerStack?.layout?.description), 1),
                      _createElementVNode("td", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          (footerStack.content_id)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                to: {name: 'edit-footer', params: { id: footerStack.content_id, type: footerStack.type.code}},
                                class: "btn btn-icon btn-primary"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_8
                                ]),
                                _: 2
                              }, 1032, ["to"]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  }), 128))
                : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}